import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Building2, Cpu, Key, Bell, Layers, BookOpen, UploadCloud, Video, CreditCard,
} from 'lucide-react';

import BrandsPanel from './settings/BrandsPanel';
import BankAccountsPanel from './settings/BankAccountsPanel';
import ProjectTypesPanel from './settings/ProjectTypesPanel';
import CatalogPanel from './settings/CatalogPanel';
import IntegrationsPanel from './settings/IntegrationsPanel';
import AISkillsPanel from './settings/AISkillsPanel';
import NotificationsPanel from './settings/NotificationsPanel';
import UploadsPanel from './settings/UploadsPanel';
import ZoomPanel from './settings/ZoomPanel';

const SETTING_TABS = [
  { id: 'brands', label: 'Brands', icon: Building2 },
  { id: 'bank-accounts', label: 'Bank Accounts', icon: CreditCard },
  { id: 'project-types', label: 'Project Types', icon: Layers },
  { id: 'catalog', label: 'Task Catalog', icon: BookOpen },
  { id: 'integrations', label: 'Integrations', icon: Key },
  { id: 'ai', label: 'AI Skills', icon: Cpu },
  { id: 'notifications', label: 'Notifications', icon: Bell },
  { id: 'uploads', label: 'Uploads (R2)', icon: UploadCloud },
  { id: 'zoom', label: 'Zoom', icon: Video },
];

export default function Settings() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(tab || 'brands');

  const handleTabChange = (id) => {
    setActiveTab(id);
    navigate(`/admin/settings/${id}`, { replace: true });
  };

  return (
    <div className="p-6 animate-fade-in" data-testid="settings-page">
      <h1 className="text-xl font-black mb-4" style={{ color: 'var(--ink)' }}>Settings</h1>

      <div className="flex gap-6">
        {/* Left nav */}
        <div className="w-48 flex-shrink-0">
          <nav className="space-y-0.5">
            {SETTING_TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => handleTabChange(id)}
                className="flex items-center gap-2.5 w-full px-3 py-2 rounded-btn text-sm font-medium text-left transition-colors"
                style={{
                  background: activeTab === id ? '#E6F1F4' : 'transparent',
                  color: activeTab === id ? '#006080' : 'var(--muted)',
                }}
                data-testid={`settings-tab-${id}`}
              >
                <Icon size={15} strokeWidth={2} />
                {label}
              </button>
            ))}
          </nav>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {activeTab === 'brands' && <BrandsPanel />}
          {activeTab === 'bank-accounts' && <BankAccountsPanel />}
          {activeTab === 'project-types' && <ProjectTypesPanel />}
          {activeTab === 'catalog' && <CatalogPanel />}
          {activeTab === 'integrations' && <IntegrationsPanel />}
          {activeTab === 'ai' && <AISkillsPanel />}
          {activeTab === 'notifications' && <NotificationsPanel />}
          {activeTab === 'uploads' && <UploadsPanel />}
          {activeTab === 'zoom' && <ZoomPanel />}
        </div>
      </div>
    </div>
  );
}
